<template>
  <div id="expense-detail-storage-fee-list" class="panel-body">
    <expense-detail-table
      :url="'/Delivery/expense-detail/storage-fee'"
      :extraUrl="[]"
      :method="'get'"
      :clientMode="false"
      :columns="$options.columns"
      :isSearchable="true"
      :searchValue="keyword"
      @countData="countData = $event"
      :needExtraData="true"
      @extraData="extraData = $event"
      @keyword="onHandleSearch"
      @confirmDownloadCsv="openModalConfirmDownloadCsv"
      ref="expenseDetailStorageFeeTable"
    >
      <template slot="detailDate" slot-scope="props">
        <span>{{ formatDate(props.rowData.detailDate) }}</span>
      </template>
      <template slot="detail" slot-scope="props">
        <div v-html="props.rowData.detail" class="mr-r-5"></div>
      </template>
      <template slot="serviceName" slot-scope="props">
        <span>{{ props.rowData.serviceName }}</span>
      </template>
      <template slot="size" slot-scope="props">
        <span>{{ sizeName(props.rowData.size) }}</span>
      </template>
      <template slot="quantity" slot-scope="props">
        <span>{{ props.rowData.quantity }}</span>
      </template>
      <template slot="unitCost" slot-scope="props">
        <span>{{ formatAmount(props.rowData.unitCost) }}</span>
      </template>
      <template slot="cost" slot-scope="props">
        <span>{{ formatAmount(props.rowData.cost) }}</span>
      </template>
    </expense-detail-table>

    <modal-confirm-download-csv
      v-if="showModalConfirmDownloadCsv"
      :message="`セルモン倉庫の費用明細（保管料等）CSVをダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。`"
      @close="closeModalConfirmDownloadCsv"
      @downloadCsv="handleDownloadCsv"
    />
 </div>
</template>

<script>
import moment from 'moment'
import ExpenseDetailTable from './ExpanseDetailTable.vue'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ModalConfirmDownloadCsv from '@/view/deliveryRequests/components/ModalConfirmDownloadCsv.vue'
import DeliveryService from '@/services/deliveryservice'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ExpenseDetailTable,
    ModalConfirmDownloadCsv
  },
  data () {
    return {
      keyword: null,
      search: null,
      showModalConfirmDownloadCsv: false,
      filters: {
        detail: null,
        from: null,
        to: null
      }
    }
  },
  columns: [
    {
      title: '日付',
      name: 'detailDate',
      cellClass: 'text-center',
      headerClass: 'text-center w-180'
    },
    {
      title: '明細',
      name: 'detail',
      cellClass: '',
      headerClass: 'text-center header-detail'
    },
    {
      title: 'サービス名',
      name: 'serviceName',
      cellClass: '',
      headerClass: 'text-center w-150'
    },
    {
      title: 'サイズ',
      name: 'size',
      cellClass: '',
      headerClass: 'text-center w-100'
    },
    {
      title: '数量',
      name: 'quantity',
      cellClass: 'text-right',
      headerClass: 'text-center w-100'
    },
    {
      title: '単価(税抜)',
      name: 'unitCost',
      cellClass: 'text-right',
      headerClass: 'text-center w-100'
    },
    {
      title: '金額(税抜)',
      name: 'cost',
      cellClass: 'text-right',
      headerClass: 'text-center w-120'
    }
  ],
  mounted () {
    let self = this
    this.$events.listen('apiSuccess', (url) => {
      if (url === '/Delivery/expense-detail/storage-fee') {
        self.loader && self.loader.hide()
      }
    })
    if (this.currentTab && this.currentTab === 'expense-detail-storage-fee') {
      let logParams = {
        name: eventCode.delivery_requests.expense_detail_storage_fee_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  methods: {
    formatAmount (value) {
      return `¥${Util.formatMoney(value, 1, '.', '')}`
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : null
    },
    onHandleSearch (keyword) {
      let logParams = {
        name: eventCode.delivery_requests.expense_detail_storage_fee_tab.click_search_button,
        properties: keyword
      }
      EventService.postTrackLog(logParams)

      this.filters = keyword
    },
    sizeName (size) {
      let sizeName = null
      let arrSize = {
        '30': 'ネコポス',
        '60': '60サイズ',
        '80': '80サイズ',
        '100': '100サイズ',
        '120': '120サイズ',
        '140': '140サイズ',
        '160': '160サイズ',
        '180': '180サイズ',
        '200': '200サイズ'
      }
      sizeName = arrSize[size]
      return sizeName
    },
    async handleDownloadCsv () {
      let logParams = {
        name: eventCode.delivery_requests.expense_detail_storage_fee_tab.click_download_csv_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let sellerId = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `salmonWarehouse_otherCost_${sellerId}_${reportTime}.csv`
      let params = {
        sellerId: sellerId,
        detail: this.filters.detail,
        from: this.filters.from,
        to: this.filters.to,
        costType: 'otherCost'
      }

      this.closeModalConfirmDownloadCsv()
      await DeliveryService.postExport(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openModalConfirmDownloadCsv () {
      this.showModalConfirmDownloadCsv = true
    },
    closeModalConfirmDownloadCsv () {
      $('#confirm-download-cvs-modal').modal('hide')
      this.showModalConfirmDownloadCsv = false
    }
  }
}
</script>

<style scoped>
@media (max-width: 1200px) {
  #expense-detail-storage-fee-list /deep/ .table-wrapper {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  #expense-detail-storage-fee-list /deep/ .table {
    width: max-content;
    max-width: max-content;
  }
  #expense-detail-storage-fee-list /deep/ .header-detail {
    width: 500px;
  }
  #expense-detail-storage-fee-list /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #expense-detail-storage-fee-list /deep/ .box-base-table-search .sale-detail-search {
    display: block;
  }
  #expense-detail-storage-fee-list /deep/ .box-base-table-search .search-block {
    display: block;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/ExpenseDetailStorageFee.vue